/**
 * LetterScoring — per-letter point values and word scoring.
 *
 * Values follow the classic Scrabble distribution (frequency-based):
 * rare letters score higher, common letters score lower.
 *
 * This module only computes the raw score from letters.
 * Combat damage modifiers live in DamageCalculator.
 */

/** Point value for each letter (Scrabble-standard). */
const LETTER_VALUES: Record<string, number> = {
  A: 1, B: 3, C: 3, D: 2, E: 1, F: 4, G: 2, H: 4, I: 1,
  J: 8, K: 5, L: 1, M: 3, N: 1, O: 1, P: 3, Q: 10, R: 1,
  S: 1, T: 1, U: 1, V: 4, W: 4, X: 8, Y: 4, Z: 10,
};

export function getLetterValue(letter: string): number {
  return LETTER_VALUES[letter.toUpperCase()] ?? 0;
}

/**
 * Score a word by summing its letter values.
 *
 * This is the base score — no length bonuses or multipliers.
 * Those belong in DamageCalculator or future combo systems.
 */
export function scoreWord(word: string): number {
  let total = 0;
  for (const ch of word) {
    total += getLetterValue(ch);
  }
  return total;
}
